import styled from 'styled-components'

export const WrapperError = styled.div`
  padding-top: 10px;
`

export const WrapperTitles = styled.div`
  margin-top: 15px;
`
